import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown } from "antd";

import { NotificationAction } from "../../../../store/actions";
import NotificationNavs from "./notificationnavs";
import images from "../../../../assets";

const items = [
  {
    label: <NotificationNavs />,
    key: "0",
  },
];

const NotificationDropdownContainer = (props) => {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state) => state.notifications);

  const [allRead, setAllRead] = useState(true);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [hasOpenedOnce, setHasOpenedOnce] = useState(false);

  useEffect(() => {
    const hasUnread = notifications.some(
      (notification) => notification.status === "unread"
    );
    setAllRead(!hasUnread);
  }, [notifications]);

  useEffect(() => {
    if (!dropdownVisible && hasOpenedOnce && !allRead) {
      dispatch(NotificationAction.markAsSeen());
    }
  }, [dropdownVisible, hasOpenedOnce, allRead, dispatch]);

  const handleDropdownVisibleChange = (visible) => {
    setDropdownVisible(visible);

    if (visible) {
      if (!hasOpenedOnce) {
        setHasOpenedOnce(true);
      }
    }
  };

  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      placement="bottom"
      overlayStyle={{
        top: props?.promotionheader ? "130px" : "80px",
      }}
      onOpenChange={handleDropdownVisibleChange}
    >
      <img
        className="notification-bell"
        src={allRead ? images.notificationRead : images.notification}
        alt="Notification"
      />
    </Dropdown>
  );
};

export default NotificationDropdownContainer;
